import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CategoriesWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1.6),
}));
